import { createContext, useContext, useEffect } from "react";

const ThemeContext = createContext(null);

/**
 * Tema fixo do AutEM: azul institucional, modo claro.
 *
 * A escolha de cor por tenant foi descontinuada (a tela Configurações >
 * Gerais > Aparência não existe mais). O valor legado `theme_color` em
 * `tenant_settings` é simplesmente ignorado.
 */
const ACCENT = { id: "blue", name: "Azul", color: "#00AFE5", hover: "#0095C5" };

function hexToRgb(hex) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `${r}, ${g}, ${b}`;
}

export function ThemeProvider({ children }) {
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--accent", ACCENT.color);
    root.style.setProperty("--accent-hover", ACCENT.hover);
    root.style.setProperty("--accent-rgb", hexToRgb(ACCENT.color));
    root.style.setProperty("--accent-light", `rgba(${hexToRgb(ACCENT.color)}, 0.1)`);
  }, []);

  return (
    <ThemeContext.Provider
      value={{
        mode: "light",
        isDark: false,
        darkModeAvailable: false,
        accentId: ACCENT.id,
        accent: ACCENT,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
